/*
*******************************************************************************************
This Enum is sorted alphabetically. Please consider this when you are adding new event type
*******************************************************************************************
*/

export enum GtmTemplateTypeEnum {
  Category = 'category',
  HomePage = 'homepage',
  ProductDetail = 'product detail',
  Other = 'other',
  TermsAndConditions = 'terms&conditions'
}
